import * as React from 'react';
import styled from 'styled-components';


interface StyleProps {
  shape: string;
}
const Wrap = styled.div<StyleProps>`
  position: absolute;
  ${props => props.shape === 'top' ? 
  ('top: -120px; left: 0; width: 320px;') : 
  ('bottom: 0; right: 0; width: 350px;')}
  & img {
    width: 100%;
  }
`;

interface IProps {
  shape: string;
}

const Flower = ({shape}: IProps) => {
  return (
    <Wrap shape={shape}>
      <img src={require(shape === 'top' ? "../../assets/gift/flower_top@2x.png" : "../../assets/gift/flower_bottom@2x.png")} alt="flower" />
    </Wrap>
  );
};

export default Flower;



// WEBPACK FOOTER //
// ./src/components/gift/flower.tsx